module.exports = __webpack_public_path__ + "static/media/unispace.efdec917.png";